import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import BgImg from "../../images/services-usa/generative-ai/generative_ai_choose.webp";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "Comprehensive Expertise",
    description:
      "Leverage our consulting, advisory, and delivery services, built on extensive industry knowledge. We address your most pressing challenges with customized, impactful solutions.",
    count: "01",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Seamless Gen AI Integration",
    description:
      "Implement AI seamlessly, blending advanced technological capabilities with human expertise. Our approach ensures smooth adoption, driving efficiency and innovation in your operations.",
    count: "02",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ethical AI Practices",
    description:
      "Utilize AI confidently with our commitment to responsible AI. We ensure your solutions adhere to the highest standards of ethics, transparency, and responsibility.",
    count: "03",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Strategic Transformation",
    description:
      "Benefit from our expertise in orchestrating complex transformations across diverse platforms. Our strategic approach guarantees scalable solutions that accelerate business growth.",
    count: "04",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Industry-Specific Knowledge",
    description:
      "Rely on our deep domain expertise and industry insights to develop flexible, reusable platforms. We tailor solutions to your unique needs, ensuring practical and innovative outcomes.",
    count: "05",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Performance Optimization",
    description:
      "Achieve optimal performance with our AI-driven solutions. We focus on enhancing operational efficiency, reducing costs, and maximizing your return on investment through advanced technology.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow p-100 generative_ai_choose tekrevol_dark_bg"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose TekRevol for <span>Generative AI Services</span>
            </h2>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-5"
          >
            {/* <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
